module.exports = __webpack_public_path__ + "img/C08TechElephantTraining_ua.1c0a76e5.webp";